import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/sites')({
  component: SitesLayout,
});

function SitesLayout() {
  return <Outlet />;
}
